import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reviewsSelector } from '../../../../../store/slices/reviews';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Typography } from '@mui/material';



const EmployeeName = () => {
  const { similarReviews } = useSelector(reviewsSelector);

  const empData = useMemo(() => {
    const tempStore = similarReviews?.agents?.employeeName;
    const parsed = tempStore ? JSON.parse(tempStore) : {};
    return parsed?.EmployeeName || {};
  }, [similarReviews?.agents?.employeeName]);

  const initialNames = empData.InitialNameList || [];
  const included = empData.IncludedNames || [];
  const ignored = empData.IgnoredNames || [];


  const ignoredData = useMemo(() => {
    return ignored.map((item) => ({
      ignoredName: item?.IgnoredName || '',
      ignoredReasoning: item?.Reasoning || '',
    }));
  }, [ignored]);

  const ignoredColumns = useMemo(() => [
    { accessorKey: 'ignoredName', header: 'Ignored Names', },
    { accessorKey: 'ignoredReasoning', header: 'Reasoning' , muiTableHeadCellProps: { sx: { pl: 55 } },
      muiTableBodyCellProps: { sx: { pl: 55, border: 'none' } 
    },},
    
  ], []);

  const ignoredTable = useMaterialReactTable({
    columns: ignoredColumns,
    data: ignoredData,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: { sx: { maxHeight: 'unset' } },
    muiTablePaperProps: { className: 'std_table review-requests', sx: { boxShadow: 'none' } },
    muiTableBodyCellProps: { sx: { border: 'none' } },
  });

  const includedData = useMemo(() => {
    return included.map((item) => ({
      includedName: item?.EmployeeName || '',
      responseName: item?.ResponseName || '',
      includedReasoning: item?.Reasoning || '',
    }));
  }, [included]);

  const includedColumns = useMemo(() => [
    { accessorKey: 'includedName', header: 'Employee Name' },
    { accessorKey: 'responseName', header: 'Response Name',muiTableHeadCellProps: { sx: { pl: 10 } },
     muiTableBodyCellProps: { sx: { pl: 10,border: 'none' } }},
    { accessorKey: 'includedReasoning', header: 'Reasoning' },
  ], []);

  const includedTable = useMaterialReactTable({
    columns: includedColumns,
    data: includedData,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: { sx: { maxHeight: 'unset' } },
    muiTablePaperProps: { className: 'std_table review-requests', sx: { boxShadow: 'none' } },
    muiTableBodyCellProps: { sx: { border: 'none' } },
  });
  

  return (
    <Box>
      <MaterialReactTable table={includedTable} />
      <Box sx={{ my: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1,ml:1.5 }}> <strong>Initial Name List:</strong></Typography>
        <Typography variant="body2">
          {initialNames.join(',') || ''}
        </Typography>
      </Box>
      <MaterialReactTable table={ignoredTable} />
    </Box>
  );
};

export default EmployeeName;






